module.exports = __webpack_public_path__ + "img/icon-1-2.c06f42f1.png";